export const INTEGRATION_CONNECT_QUERY_PARAM = "connect";
export const INTEGRATION_DETAIL_QUERY_PARAM = "integration";
export const INTEGRATION_CONNECT_REQUEST_QUERY_PARAM = "connect_request_id";
export const INTEGRATION_DETAIL_REQUEST_QUERY_PARAM = "integration_request_id";

export type IntegrationRouteIntent =
  | { kind: "overview" }
  | { kind: "connect"; provider: string; requestId: string | null }
  | { kind: "detail"; provider: string; requestId: string | null };

const readTrimmedQueryParam = (params: URLSearchParams, key: string) => {
  const value = params.get(key)?.trim();
  return value || null;
};

/**
 * `connect` is a one-shot connection flow, while `integration` is addressable
 * page state. Keep their meanings separate so opening a provider detail never
 * starts OAuth or opens a credential form as a side effect.
 */
export const readIntegrationRouteIntent = (
  params: URLSearchParams,
): IntegrationRouteIntent => {
  const connectProvider = readTrimmedQueryParam(
    params,
    INTEGRATION_CONNECT_QUERY_PARAM,
  );
  if (connectProvider) {
    return {
      kind: "connect",
      provider: connectProvider,
      requestId: readTrimmedQueryParam(
        params,
        INTEGRATION_CONNECT_REQUEST_QUERY_PARAM,
      ),
    };
  }

  const detailProvider = readTrimmedQueryParam(
    params,
    INTEGRATION_DETAIL_QUERY_PARAM,
  );
  if (detailProvider) {
    return {
      kind: "detail",
      provider: detailProvider,
      requestId: readTrimmedQueryParam(
        params,
        INTEGRATION_DETAIL_REQUEST_QUERY_PARAM,
      ),
    };
  }

  return { kind: "overview" };
};

export const writeIntegrationRouteIntent = (
  params: URLSearchParams,
  intent: IntegrationRouteIntent,
) => {
  params.delete(INTEGRATION_CONNECT_QUERY_PARAM);
  params.delete(INTEGRATION_DETAIL_QUERY_PARAM);
  params.delete(INTEGRATION_CONNECT_REQUEST_QUERY_PARAM);
  params.delete(INTEGRATION_DETAIL_REQUEST_QUERY_PARAM);

  if (intent.kind === "overview") {
    return;
  }

  const providerParam =
    intent.kind === "connect"
      ? INTEGRATION_CONNECT_QUERY_PARAM
      : INTEGRATION_DETAIL_QUERY_PARAM;
  const requestParam =
    intent.kind === "connect"
      ? INTEGRATION_CONNECT_REQUEST_QUERY_PARAM
      : INTEGRATION_DETAIL_REQUEST_QUERY_PARAM;

  params.set(providerParam, intent.provider);
  if (intent.requestId) {
    params.set(requestParam, intent.requestId);
  }
};
